import React from 'react';
import PropTypes from 'prop-types';

const ActionButton = props => {
  return (
    props.show ? (
    <input
      type="button"
      className="action"
      onClick={props.onClick}
      value={props.text}
    />
    ) : null
  );
};

ActionButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  show: PropTypes.bool
};

ActionButton.defaultProps = {
  show: true
};

export default ActionButton;